import { Table } from 'antd';
import { calculateColumnsWidth } from 'api/common';
import { LoadingScreen } from 'common/components';
import { createContext, useState, useEffect, useRef } from 'react';
import FilterApprovrovedColumn from './FilterApprovrovedColumn';
import {
  MandateApprovePagedList,
  getMandateApproveList,
  MandateApproveFilterPayload,
} from 'api/nach';

let payPagedList: MandateApprovePagedList = { currentPageIndex: 1, noOfRecords: 10, data: [] };

type Props = {
  filter: MandateApproveFilterPayload;
};

export const NachDashboardRetryContext = createContext<any>(null);

const MandateList = ({ filter }: Props) => {
  const [pagedList, setPagedList] = useState(payPagedList);
  const [isLoading, setIsLoading] = useState(true); // Default to true for loading state
  const [isRetry, setIsRetry] = useState(false);

  // Extract the session storage data outside of the useEffect to avoid unnecessary re-renders
  const isAdmin = sessionStorage.getItem('isAdmin') === 'true';
  const sourceApplicationName = sessionStorage.getItem('source')?.toString();

  // 2. FIXED: Changed to an instantaneous synchronous Reference Lock
  const fetchLock = useRef(false);
  useEffect(() => {
    const fetchData = async () => {

      // 3. THE MOUNT GUARD: Checked and locked synchronously in the same microsecond cycle
      if (fetchLock.current) return;
      fetchLock.current = true;

      setIsLoading(true); // Set loading true when starting fetch
      try {
        // filter.pageNo = 1;
        // filter.pageSize = 10;
        // filter.isExtract = false;
        // if (!isAdmin) {
        //   filter.sourceApplicationName = sourceApplicationName;
        // }
        // Safe shallow clone copy to isolate object mutation frames
        const payload = { ...filter };
        payload.pageNo = 1;
        payload.pageSize = 10;
        payload.isExtract = false;
        if (!isAdmin) {
          payload.sourceApplicationName = sourceApplicationName;
        }

        const res = await getMandateApproveList(payload);
        if (res.data) {
          setPagedList(res.data);
        }
        console.log('nach dashboard', res);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false); // Set loading false when fetch is complete

        // 4. RELEASE LOCK: Safe for future intentional user filter search clicks
        fetchLock.current = false;
      }
    };

    fetchData();
    //  }, [filter, isRetry, isAdmin, sourceApplicationName]); // Ensure all dependencies are included
  }, [JSON.stringify(filter), isRetry, isAdmin, sourceApplicationName]);
  if (isLoading) {
    return <LoadingScreen />;
  }

  const handleChange = async (_pagination: any, _filters: any, sorter: any) => {
    setIsLoading(true); // Set loading true when starting fetch
    try {
      if (sorter.hasOwnProperty('column')) {
        // Handle sorting
      }

      // filter.pageNo = _pagination.current;
      // filter.pageSize = _pagination.pageSize;
      // filter.isExtract = false;
      // if (!isAdmin) {
      //   filter.sourceApplicationName = sourceApplicationName;
      // }

      // Safe shallow clone copy for layout change updates too
      const payload = { ...filter };
      payload.pageNo = _pagination.current;
      payload.pageSize = _pagination.pageSize;
      payload.isExtract = false;
      if (!isAdmin) {
        payload.sourceApplicationName = sourceApplicationName;
      }

      const res = await getMandateApproveList(payload);
      if (res.data) {
        setPagedList(res.data);
      }
    } catch (error) {
      console.error('Error fetching data on change:', error);
    } finally {
      setIsLoading(false); // Set loading false when fetch is complete
    }
  };

  const maxWidthPerCell = 600;
  const dataTable = calculateColumnsWidth(
    FilterApprovrovedColumn,
    pagedList?.data || [],
    maxWidthPerCell
  );

  const tableHeight = 500;
  const rowKey = 'ROWNUM';

  return (
    <NachDashboardRetryContext.Provider value={{ setIsRetry, isRetry }}>
      <Table
        dataSource={dataTable.source}
        columns={dataTable.columns}
        rowKey={rowKey}
        pagination={{
          pageSize: 10,
          total: pagedList?.noOfRecords,
          current: pagedList?.currentPageIndex == 0 ? 1 : pagedList?.currentPageIndex,
        }}
        scroll={{ x: dataTable.tableWidth, y: tableHeight }}
        onChange={handleChange}
      />
    </NachDashboardRetryContext.Provider>
  );
};

export default MandateList;
